import { useAuth } from 'modules/auth/hooks/useAuth';

import { useAssociatedAccounts } from './useAssociatedAccounts';
import { useUserETHAddresses } from './useUserETHAddresses';

export const useInitUser = () => {
  const { isLoggedIn, isWeb3Auth } = useAuth();

  useUserETHAddresses({ skipFetching: !isLoggedIn || isWeb3Auth });

  useAssociatedAccounts({ skipFetching: !isLoggedIn || isWeb3Auth });
};
